/* tslint:disable */
/* eslint-disable */
export enum VpnServerType {
  TunServer = 'TUN_SERVER',
  TapServer = 'TAP_SERVER',
  PptpServer = 'PPTP_SERVER'
}
